export default {
      id: "linkedin-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#linkedin",
      toString: function () {
        return this.url;
      }
    }